import { FormatModule } from "tabulator-tables";
import { cygnusIconHtml } from '@root/services/cygnusIconMarkup';

export default function (formatter) {
  let _formatter = formatter;

  if (typeof _formatter === 'string') {
    _formatter = FormatModule.formatters[formatter];
  }

  if (typeof _formatter === 'undefined') {
    _formatter = FormatModule.formatters.plaintext;
  }

  return (cell, formatterParams) => {
    if (cell._loaded) {
      return _formatter(cell, formatterParams);
    }

    return `<div style="width: 100%; text-align: center; display: inline-flex; align-items: center; justify-content: center; height: 100%;">${cygnusIconHtml('spinner', { spin: true })}</div>`;
  }
}
